
import { Vue, Component, Prop, mixins } from 'nuxt-property-decorator'
import AddThis from 'vue-simple-addthis-share'
import ImageUrlS3 from '~/mixins/imageUrlS3'

@Component({
  components: {
    AddThis
  }
})
export default class PageLayoutBlog extends mixins(ImageUrlS3) {
  @Prop({ required: true }) page: Record<string, any>
}
